export default {
    active: 'active',
    inactive: 'inactive',
    pending: 'pending',
    deleted: 'deleted'
  };